export default __webpack_public_path__ + "static/media/level-basic.17f6927b.svg";